import { useEffect, useRef } from "react";

/** Katakana, numbers, and Latin letters for Matrix digital rain */
const CHARS =
  "ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝ0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const MATRIX_GREEN = "#00FF41";
const FONT_SIZE = 14;

export default function MatrixRain() {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    console.log("MatrixRain is mounting");
    const canvas = canvasRef.current;
    if (!canvas) {
      console.warn("MatrixRain: canvas ref is null");
      return;
    }

    const ctx = canvas.getContext("2d");
    if (!ctx) {
      console.warn("MatrixRain: could not get 2d context");
      return;
    }

    let animationId: number;
    let columns: { y: number; speed: number }[] = [];

    const resize = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      canvas.width = w;
      canvas.height = h;

      const colCount = Math.floor(w / FONT_SIZE);
      columns = Array.from({ length: colCount }, () => ({
        y: Math.random() * h,
        speed: 0.5 + Math.random() * 2,
      }));
    };

    const draw = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;

      ctx.fillStyle = "rgba(0, 0, 0, 0.05)";
      ctx.fillRect(0, 0, w, h);

      ctx.font = `${FONT_SIZE}px "JetBrains Mono", monospace`;

      columns.forEach((col, i) => {
        const x = i * FONT_SIZE;
        const char = CHARS[Math.floor(Math.random() * CHARS.length)];

        ctx.fillStyle = MATRIX_GREEN;
        ctx.globalAlpha = 1;
        ctx.fillText(char, x, col.y);

        ctx.globalAlpha = 0.4;
        ctx.fillText(
          CHARS[Math.floor(Math.random() * CHARS.length)],
          x,
          col.y - FONT_SIZE
        );
        ctx.fillText(
          CHARS[Math.floor(Math.random() * CHARS.length)],
          x,
          col.y - FONT_SIZE * 2
        );
        ctx.globalAlpha = 1;

        col.y += col.speed;
        if (col.y > h + FONT_SIZE) col.y = -FONT_SIZE * 2;
      });

      animationId = requestAnimationFrame(draw);
    };

    resize();
    draw();

    const handleResize = () => {
      resize();
    };
    window.addEventListener("resize", handleResize);

    return () => {
      console.log("MatrixRain is unmounting");
      window.removeEventListener("resize", handleResize);
      cancelAnimationFrame(animationId);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      aria-hidden
      className="pointer-events-none"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 0,
        pointerEvents: "none",
      }}
    />
  );
}
